import { useFont } from '@octane/spark'
import { css } from 'styled-components'

/**
 * Hero Headings
 */
export const Hero48 = css`
    ${() => useFont('h48', { weight: '700' })};
`

export const Hero36 = css`
    ${() => useFont('h36', { weight: '700' })};
`

export const Hero24 = css`
    ${() => useFont('h24', { weight: '700' })};
`

/**
 * Headings
 */
export const Heading24Bold = css`
    ${() => useFont('c24', { weight: '700' })};
`

export const Heading20Bold = css`
    ${() => useFont('c20', { weight: '700' })};
`

export const Heading16Bold = css`
    ${() => useFont('c16', { weight: '700' })}
`

/**
 * Button CTA
 */
export const ButtonMedium16 = css`
    ${() => useFont('c16', { weight: '700' })};
`

export const ButtonCompact16 = css`
    ${() => useFont('c16', { weight: '700' })};
`

/**
 * Body Styles
 */
export const BodyCopy16 = css`
    ${() => useFont('b16', { weight: '400' })};
`

export const BodyCopy12 = css`
    ${() => useFont('b12', { weight: '400' })};
`

/**
 * Copy
 */

export const Copy48 = css`
    ${() => useFont('c48', { weight: '400' })};
`

export const Copy24 = css`
    ${() => useFont('c24', { weight: '400' })};
`

export const Copy20 = css`
    ${() => useFont('c20', { weight: '400' })};
`

export const Copy16 = css`
    ${() => useFont('c16', { weight: '400' })};
`

export const Copy14 = css`
    ${() => useFont('c14', { weight: '400' })};
`

/**
 * Pulldown
 */
export const Copy16Bold = css`
    ${() => useFont('c16', { weight: '700' })};
`

/**
 * Table
 */

export const TablePrimaryHeader12 = css`
    ${() => useFont('c12', { weight: '400' })};
`

/**
 * Banner
 */
export const BannerText = css`
    ${() => useFont('c16', { weight: '700' })}
`
